import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Avatar from './avatar';
import UserAvatar from './user-avatar';
import UserContainer from '../containers/user-container';
import Tooltip from './tooltip';

import IconInvite from '../icons/icon-invite';

export default class UserFaces extends Component {
    static propTypes = {
        className: PropTypes.string,
        size: PropTypes.string,
        border: PropTypes.bool,
        action: PropTypes.object,
        users: PropTypes.array,
        subtitles: PropTypes.any,
        additionals: PropTypes.any,
        tooltip: PropTypes.bool,
        tooltipPlacement: PropTypes.string,
        tooltipContent: PropTypes.any,
        addUserTooltip: PropTypes.any,
        maxUsersCount: PropTypes.number,
        onAddUserClick: PropTypes.func,
        onPermissionChange: PropTypes.func
    };

    static defaultProps = {
        maxUsersCount: 8,
        className: '',
        tooltip: true
    };

    get addUserElement() {
        if (!this.props.onAddUserClick) {
            return null;
        }

        const addUserBtn = <button key="button" onClick={this.props.onAddUserClick} className="btn btn-action btn-colored"><IconInvite /></button>;

        if (!this.props.addUserTooltip) {
            return addUserBtn;
        }

        return <Tooltip key="tooltip" tooltip={this.props.addUserTooltip}>{addUserBtn}</Tooltip>;
    }

    get userFaceElements() {
        const avatarElements = [];
        const maxUsersCount = this.props.onAddUserClick ? this.props.maxUsersCount - 1 : this.props.maxUsersCount;
        const exceedsLimit = this.props.users.length > maxUsersCount;
        const users = (exceedsLimit ? this.props.users.slice(0, maxUsersCount) : this.props.users).filter(Boolean).map(u => u.id || u);

        return (
            <React.Fragment>
                {
                    users.map((userId, index) => (
                        <UserContainer key={userId || index} id={userId}>
                            <UserAvatar
                                size={this.props.size}
                                border={this.props.border}
                                onPermissionChange={this.props.onPermissionChange}
                                tooltip={this.props.tooltip}
                                tooltipPlacement={this.props.tooltipPlacement}
                                tooltipContent={this.props.tooltipContent}
                                showStatus={this.props.showStatus}
                                subtitle={this.props.subtitles && Array.isArray(this.props.subtitles) ? (this.props.subtitles.find(user => user.id === userId) || {}).subtitle : this.props.subtitles}
                                additional={this.props.additionals && Array.isArray(this.props.additionals) ? (this.props.additionals.find(user => user.id === userId) || {}).additional : this.props.additionals}
                                subtitleIcon={this.props.subtitleIcon}
                                onSubtitleClick={this.props.onSubtitleClick}
                                onClick={this.props.onClick}
                            />
                        </UserContainer>
                    ))
                }

                {
                    exceedsLimit ? (
                        <Avatar
                            key="remaining"
                            text={`+${this.props.users.length - maxUsersCount}`}
                            size={this.props.size}
                            border={this.props.border}
                            empty={true}
                            users={this.props.users.slice(maxUsersCount)}
                            onClick={this.props.onClick}
                        />
                    ) : null
                }

                { this.addUserElement }
            </React.Fragment>
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.className !== nextProps.className) return true;
        if (this.props.size !== nextProps.size) return true;
        if (this.props.border !== nextProps.border) return true;
        if (this.props.action !== nextProps.action) return true;
        if (this.props.users !== nextProps.users) return true;
        if (this.props.subtitles !== nextProps.subtitles) return true;
        if (this.props.additionals !== nextProps.additionals) return true;
        if (this.props.tooltip !== nextProps.tooltip) return true;
        if (this.props.tooltipPlacement !== nextProps.tooltipPlacement) return true;
        if (this.props.tooltipContent !== nextProps.tooltipContent) return true;
        if (this.props.addUserTooltip !== nextProps.addUserTooltip) return true;
        if (this.props.maxUsersCount !== nextProps.maxUsersCount) return true;
        if (this.props.onAddUserClick !== nextProps.onAddUserClick) return true;
        if (this.props.onPermissionChange !== nextProps.onPermissionChange) return true;

        return false;
    }

    render() {
        if (!this.props.users) {
            return null;
        }

        return (
            <div className={'user-faces user-faces-' + this.props.size + ' ' + this.props.className}>
                { this.userFaceElements }
            </div>
        );
    }
}
